import { render, staticRenderFns } from "./Number-input.vue?vue&type=template&id=182be55f"
import script from "./Number-input.vue?vue&type=script&lang=js"
export * from "./Number-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports